var $09e991522ca7e64e$exports = {};
"use strict";
var $09e991522ca7e64e$var$swiper = new Swiper(".mySwiper", {
    pagination: {
        el: ".swiper-pagination",
        type: "fraction"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});


//# sourceMappingURL=index.2c964a2a.js.map
